import { createFileRoute } from '@tanstack/react-router'
import { DepotForm } from '@features/stock/components/DepotForm'
import { usePermissions } from '@lib/hooks/usePermissions'
import { requirePermission } from '@lib/permissions/guards'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'

export const Route = createFileRoute('/_app/stock/depots/create')({
  beforeLoad: ({ context }) => {
    requirePermission(PERMISSIONS.STOCK.DEPOTS.CREATE, context)
  },
  component: CreateDepotComponent,
})

function CreateDepotComponent() {
  const { canCreate } = usePermissions()
  
  if (!canCreate('stock.depots.create')) {
    return <div className="p-6">Accès non autorisé</div>
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Nouveau Dépôt</h1>
      <DepotForm />
    </div>
  )
}
